import { render, staticRenderFns } from "./NoUISlider.vue?vue&type=template&id=364c646a&"
import script from "./NoUISlider.vue?vue&type=script&lang=coffee&"
export * from "./NoUISlider.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports